import _ from "lodash";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import moment from "moment-timezone";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  snapshot: {
    color: theme.palette.text.secondary,
    maxHeight: "100%",
    minHeight: "30vh",
    overflow: "auto",
    padding: theme.spacing(2),
    textAlign: "left",
  },
}));

function Overview(props) {
  const classes = useStyles();

  const {
    assetData = {},
    facilities,
    eventTypesMap = {},
    isInventorySnapshot,
  } = props;
  const {
    classificationMap = {},
    customMap,
    facilityId,
    lastEvent = "None provided",
    latitude,
    longitude,
    propertiesMap = {},
    quantity = {},
    tag = "None provided",
    timeCreatedUser,
    timeNeeded,
    zone,
  } = assetData;
  const { description = "None provided", category = "None provided" } =
    propertiesMap;
  const { quantityCurrent } = quantity;

  return (
    <Box className={classes.root}>
      <h4 style={{ textAlign: "left" }}>
        {isInventorySnapshot ? "Inventory" : "Asset"} Information
      </h4>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.snapshot} elevation={0}>
            <Grid container spacing={3}>
              {/* Asset Tag */}
              <Grid item xs={12} sm={4}>
                <strong>
                  {isInventorySnapshot ? "Inventory" : "Asset"} Tag
                </strong>{" "}
                <br />
                {tag}
              </Grid>

              {/* Description */}
              <Grid item xs={12} sm={4}>
                <strong>Description</strong> <br />
                {description}
              </Grid>

              {/* Category */}
              <Grid item xs={12} sm={4}>
                <strong>Category</strong> <br />
                {category}
              </Grid>

              {/* Facilities */}
              <Grid item xs={12} sm={4}>
                <strong>Last Location</strong> <br />
                {latitude && longitude && facilities[facilityId]
                  ? facilities[facilityId].name
                  : "None provided"}
              </Grid>

              {/* Status */}
              <Grid item xs={12} sm={4}>
                <strong>Status</strong>
                <br />
                {eventTypesMap[lastEvent]?.color ? (
                  <Box
                    style={{
                      color: eventTypesMap[lastEvent].color,
                    }}
                  >
                    {lastEvent}
                  </Box>
                ) : (
                  `${lastEvent}`
                )}
              </Grid>

              {/* Date Created User */}
              {timeCreatedUser ? (
                <Grid item xs={12} sm={4}>
                  <strong>Date Created</strong> <br />
                  {moment(timeCreatedUser, "YYYYMMDDHHmmss").format(
                    "MM/DD/YYYY"
                  ) || "None provided"}
                </Grid>
              ) : null}

              {/* Date needed */}
              {timeNeeded ? (
                <Grid item xs={12} sm={4}>
                  <strong>Date Needed</strong> <br />
                  {moment(timeNeeded, "YYYYMMDDHHmmss").format("MM/DD/YYYY") ||
                    "None provided"}
                </Grid>
              ) : null}

              {/* Bin Location */}
              {zone && zone.binLocation ? (
                <Grid item xs={12} sm={4}>
                  <strong>Bin Location</strong> <br />
                  {zone.binLocation}
                </Grid>
              ) : null}

              {/* Customs */}
              {customMap && !_.isEmpty(customMap)
                ? Object.keys(customMap)
                    .sort((a, b) => {
                      if (a === b) {
                        return 0;
                      } else {
                        return a.localeCompare(b);
                      }
                    })
                    .map((key, idx) => {
                      if (customMap[key]) {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={key === "note" ? 12 : 4}
                            key={`${idx} - ${key}`}
                            style={{ whiteSpace: "pre-wrap" }}
                          >
                            <strong>
                              {key === "note" ? "Notes" : _.startCase(key)}
                            </strong>{" "}
                            <br />
                            {customMap[key]}
                          </Grid>
                        );
                      }
                      return null;
                    })
                : null}

              {/* Asset Data */}
              {propertiesMap && !_.isEmpty(propertiesMap)
                ? Object.keys(propertiesMap)
                    .filter((key) => key === "note")
                    .map((key, idx) => {
                      if (
                        propertiesMap[key] &&
                        typeof propertiesMap[key] === "string"
                      ) {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={key === "note" ? 12 : 4}
                            key={`${idx} - ${key}`}
                            style={{ whiteSpace: "pre-wrap" }}
                          >
                            <strong>
                              {key === "note" ? "Notes" : _.startCase(key)}
                            </strong>{" "}
                            <br />
                            {propertiesMap[key]}
                          </Grid>
                        );
                      }
                      return null;
                    })
                : null}

              {/* Classifications */}
              {Object.keys(classificationMap).map((item, index) => {
                return (
                  <Grid item key={`${item}-${index}`} sm={4} xs={12}>
                    <strong>{item}</strong>
                    <br />
                    {classificationMap[item]}
                  </Grid>
                );
              })}

              {/* Quantity Current */}
              {quantityCurrent ? (
                <Grid item xs={12} sm={4}>
                  <strong>Quantity Qty</strong>
                  <br />
                  {quantityCurrent}
                </Grid>
              ) : null}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Overview;
